import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EcommerceAccountService } from '@core/services/admin/ecommerce-account.service';
import { APP_SLUGS, MAIN_SLUGS, PRODUCTS_SLUGS } from '@routes/routes.types';

export const ecommerceGuard: CanActivateFn = () => {
    const ecommerceAccountS = inject(EcommerceAccountService);
    const router = inject(Router);

    if (!ecommerceAccountS.account()?.platform) {
        router.navigate([APP_SLUGS.MAIN, MAIN_SLUGS.commerce, PRODUCTS_SLUGS.landing]);
        return false;
    }

    return true;
};
